import { createSelector } from 'reselect';
import { apiCallStatus } from 'helpers/constants';
import { createErrorDataSelector } from 'selectors/selectorUtils';

const getLoggers = ({ eventDetailsCMD }) => {
	return eventDetailsCMD?.loggers?.data;
};

const geteventLogDateKind = ({ eventLog }) => {
	return eventLog.dateKind;
};

const getLoggersLoadingStatus = ({ eventDetailsCMD }) => {
	return eventDetailsCMD.loggers?.loadingStatus;
};

const getLoggerFileLoadingStatus = ({ eventDetailsCMD }) => {
	return eventDetailsCMD.loggerFile?.loadingStatus;
};

const getLoggerId = ({ eventDetailsCMD }) => eventDetailsCMD.loggerId?.data;

const getLoggersRawError = ({ eventDetailsCMD }) => {
	const loggerId = eventDetailsCMD.loggerId;
	const loggers = eventDetailsCMD.loggers;
	const loggerFile = eventDetailsCMD.loggerFile;

	if (loggerId?.loadingStatus === apiCallStatus.ERROR && loggerId?.error) {
		return { error: loggerId.error, errorCode: loggerId.error?.statusCode, loadingStatus: loggerId.loadingStatus };
	}
	if (loggers?.loadingStatus === apiCallStatus.SUCCESS && loggerFile?.loadingStatus === apiCallStatus.ERROR && loggerFile?.error) {
		return { error: loggerFile.error, errorCode: loggerFile.error?.statusCode, loadingStatus: loggerFile.loadingStatus };
	}
	return { error: loggers?.error, errorCode: loggers?.error?.statusCode, loadingStatus: loggers?.loadingStatus };
};

const getLoggersErrorData = createErrorDataSelector(getLoggersRawError);

export const getModel = createSelector([
	getLoggers,
	geteventLogDateKind,
	getLoggersLoadingStatus,
	getLoggerFileLoadingStatus,
	getLoggerId,
	getLoggersErrorData,
],
	(
		loggers,
		dateKind,
		loggersLoadingStatus,
		loggerFileLoadingStatus,
		loggerId,
		errorData
	) => {
		return {
			loggers,
			dateKind,
			loggersLoadingStatus,
			loggerFileLoadingStatus,
			loggerId,
			errorData
		};
	});
